import * as React from 'react';
import { IIconProps } from '@cian/ui-kit/icons/internal/types';

export const IconCianLogo12 = ({ color }: IIconProps) => {
  const currentColor = color ? `var(--${color})` : 'currentColor';

  return (
    // eslint-disable-next-line react/forbid-elements
    <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 1C12.5523 1 13 1.44772 13 2V6.48438L14.7285 8.55957C15.0821 8.98385 15.0249 9.61421 14.6006 9.96777L12.6807 11.5684C12.4769 11.7381 12.2133 11.8199 11.9492 11.7959C11.6852 11.7718 11.4412 11.6441 11.2715 11.4404L8 7.51367L4.72852 11.4404C4.55874 11.6441 4.31482 11.7719 4.05078 11.7959C3.78677 11.8198 3.52397 11.7381 3.32031 11.5684L1.39941 9.96777C0.975504 9.61421 0.918196 8.98374 1.27148 8.55957L7.23242 1.40723L7.30762 1.32617C7.49274 1.14834 7.74049 1.04696 8 1.04688C8.29678 1.04687 8.57856 1.17923 8.76855 1.40723L9.03711 1.73047C9.15475 1.3092 9.54122 1.00011 10 1H12Z"
        fill={currentColor}
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
};
